import Vue from 'vue';
import store from './../../store';
import clientTransformer from './../../transformers/client';

const success = ({ data }, resolve) => {
  const clients = clientTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllClients', clients);
  resolve(clients);
};

const failed = (error, reject) => reject(error);


export default (search = null, clientParent = null) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(search === null ? '/clients' : `/clients?search=${search}&client_parent=${clientParent}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/all.js